import { openCopilotOverlay } from '@/shared/stores/ui';

import type { SourceProposedActionT } from '@/shared/lib';

export interface RxWizardPrefill {
  kind: 'coded';
  dispensableDrugId: number;
  directions: string;
  quantity: string;
  refills: string;
  daysSupply: string;
  pharmacyId?: number;
  pharmacyNotes?: string;
  noSubstitutions?: boolean;
  effectiveDate?: string; // YYYY-MM-DD
  sourceProposedAction?: SourceProposedActionT;
  /**
   * When set, the wizard skips prescription creation and goes straight to
   * `orchestrator.send()` with this ID and `skipPaGate: true`. Used by the
   * PA-completed view for partially-approved cases where the Rx has already
   * been edited with payer-adjusted values before the wizard opens.
   */
  existingDosespotPrescriptionId?: string;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    rxWizard: RxWizardPrefill | null;
  }
}

/**
 * Open the prescription wizard. Pass ``null`` to open it empty for manual
 * entry, or a prefill to seed it from a proposed action / PA flow.
 */
export function openRxWizardOverlay(prefill: RxWizardPrefill | null): void {
  openCopilotOverlay('rxWizard', prefill);
}
